import { useEffect, useRef, useState } from "react";
import axios from "axios";
import DynamicText from "./DynamicText.tsx";
import { useFlowStore } from "../../store/FlowStateStore.ts";
import { CanvasNode, CanvasNodeData } from "../../models/CanvasNode.ts";
import LinkHandler from "./LinkHandler.tsx";
import { Environment as environment } from "../../environment.ts";

interface Attribute {
    attributeId: string;
    attributeName: string;
    attributeType: 'TEXT' | 'NUMBER' | 'ARRAY' | 'OBJECT' | 'BOOLEAN';
    businessId: string;
}

const Attribute: React.FC<any> = (data) => {

    const { nodes, setNodes, businessId } = useFlowStore();
    const [attributes, setAttributes] = useState<Attribute[]>([]);
    const [attribute, setAttribute] = useState<string>("");
    const [attributeValue, setAttributeValue] = useState<string>("");
    const savedAttributeRef = useRef<string | null>(null);
    const isFirstRunRef = useRef(true);

    const getAllAtributes = () => {
        const payload = {
            businessId: businessId,
            page: 0,
            size: 100,
            templateStatus: null,
            searchText: ''
        }
        axios.put(`${environment.baseUrl}/fetch/attribute`, payload).then((response) => {
            const list = response.data.data.data;
            setAttributes(list);
            // Don't clobber a restored selection with the first fetched attribute.
            if (!savedAttributeRef.current && list.length > 0) {
                setAttribute(list[0].attributeName);
            }
        }).catch((error) => { });
    }

    useEffect(() => {
        const node = nodes.find((n) => n.data.id === data.nodeId);
        if (node) {
            const content = (node.data as CanvasNodeData).content.find((c) => c.id === data.subNodeId);
            if (content?.data) {
                const d = content.data as Record<string, string>;
                if (d.attribute) {
                    setAttribute(d.attribute);
                    savedAttributeRef.current = d.attribute;
                }
                setAttributeValue(d.value || "");
            }
        }
    }, []);

    useEffect(() => {
        getAllAtributes();
    }, []);

    useEffect(() => {
        // Skip the very first run: it fires with pristine default state, before the
        // restore effect's setState calls above have flowed through a re-render —
        // writing them here would clobber a just-restored value with blanks/defaults.
        if (isFirstRunRef.current) {
            isFirstRunRef.current = false;
            return;
        }
        const updatedNodes = nodes.map((node) => {
            if (node.data.id == data.nodeId) {
                return {
                    ...node,
                    data: {
                        ...node.data,
                        content: [...(node.data as CanvasNodeData).content.map((nodeContent) => {
                            if (nodeContent.id == data.subNodeId) {
                                return {
                                    ...nodeContent,
                                    data: {
                                        attribute: attribute,
                                        value: attributeValue
                                    }
                                }
                            }
                            return nodeContent
                        })]
                    }
                }
            }
            return node;
        });
        setNodes([...(updatedNodes as CanvasNode[])]);
    }, [attributeValue, attribute]);


    return (
        <div className="node-body">
            <div>
                <span className="font-label">Select Attribute</span>
                <select value={attribute} onChange={(event) => setAttribute(event.target.value)}>
                    {
                        attributes.map((attr) => {
                            return (<option key={attr.attributeId} value={attr.attributeName}>{attr.attributeName} ({attr.attributeType})</option>)
                        })
                    }
                </select>
            </div>
            <div>
                <span className="font-label">Enter or paste value</span>
                <DynamicText
                    placeholder="Enter or paste value"
                    value={attributeValue}
                    setValue={(val: string) => setAttributeValue(val)}
                    maxLength={20}
                />
            </div>
            <LinkHandler />
        </div>
    )
}

export default Attribute;
